import React from "react";
import { Loader2 } from "lucide-react";

const IMPROVE_ACTIONS = [
  { id: "generate_section", label: "Generate section" },
  { id: "rewrite", label: "Rewrite" },
  { id: "expand", label: "Expand" },
  { id: "shorten", label: "Shorten" },
  { id: "simplify", label: "Simplify" },
  { id: "add_example", label: "Add example" },
  { id: "add_case_study", label: "Add case study" },
  { id: "add_checklist", label: "Add checklist" },
  { id: "add_action_steps", label: "Add action steps" },
  { id: "improve_transition", label: "Improve transition" },
];

export default function WriteAssistantPanel({
  generated,
  approved,
  pct,
  words,
  statusLabel,
  images,
  selectedChapter,
  selectedBlock,
  busy,
  onGenerateChapter,
  onRegenerateChapter,
  onApprove,
  onRecommendVisuals,
  onImprove,
  improveBusy,
}) {
  return (
    <>
      <section className="bww-right-section">
        <h3>Book progress</h3>
        <div className="bww-progress-card">
          <strong data-testid="bl-progress-summary">{generated} generated · {approved} approved</strong>
          <div className="bww-progress-bar"><div style={{ width: `${pct}%` }} /></div>
        </div>
      </section>
      <section className="bww-right-section">
        <h3>Current chapter</h3>
        <div className="bww-metric-grid">
          <div className="bww-metric"><span>Words</span><strong data-testid="bl-word-count">{words}</strong></div>
          <div className="bww-metric"><span>Status</span><strong>{statusLabel}</strong></div>
          <div className="bww-metric"><span>Reading</span><strong>{Math.max(words ? 1 : 0, Math.ceil(words / 220))} min</strong></div>
          <div className="bww-metric"><span>Images</span><strong>{images}</strong></div>
        </div>
      </section>
      <section className="bww-right-section">
        <h3>Chapter actions</h3>
        <div className="bww-action-list">
          <button type="button" className="bww-assistant-action" data-testid="bl-generate-current"
            disabled={!selectedChapter || busy[`ch-${selectedChapter?.id}`]}
            onClick={() => selectedChapter && onGenerateChapter(selectedChapter.id)}>
            {busy[`ch-${selectedChapter?.id}`] ? "Generating…" : "Generate this chapter"}
          </button>
          <button type="button" className="bww-assistant-action"
            disabled={!selectedChapter || busy[`ch-${selectedChapter?.id}`]}
            onClick={() => selectedChapter && onRegenerateChapter(selectedChapter.id)}>
            Regenerate chapter
          </button>
          <button type="button" className="bww-assistant-action" data-testid="bl-approve-current"
            disabled={!selectedChapter || busy.approve} onClick={onApprove}>
            Mark approved
          </button>
          <button type="button" className="bww-assistant-action" onClick={onRecommendVisuals}>
            Recommend chapter visuals
          </button>
        </div>
      </section>
      <section className="bww-right-section">
        <h3>Improve selected block</h3>
        <p>
          {selectedBlock
            ? `Editing ${selectedBlock.type.replace(/_/g, " ")}`
            : "Select a text block on the page to enable AI writing actions."}
        </p>
        <div className="bww-action-list">
          {IMPROVE_ACTIONS.map((a) => (
            <button
              key={a.id}
              type="button"
              className="bww-assistant-action"
              data-testid={`bl-improve-${a.id}`}
              disabled={!selectedBlock || !!improveBusy}
              title={!selectedBlock ? "Select a block first" : undefined}
              onClick={() => onImprove(a.id)}
            >
              {improveBusy === a.id ? <><Loader2 className="animate-spin" size={12} /> Working…</> : a.label}
            </button>
          ))}
        </div>
      </section>
    </>
  );
}
